import React, { useEffect, useRef, useState } from "react";
import l from "components/util/l";
import swal from "sweetalert";
import { usePost } from "seed/api";

const useDraft = ({
  flow,
  revisionId,
  isDeveloper = false
}) => {

  const [draftRevisionId, setDraftRevisionId] = useState(null);
  const draftRevisionIdRef = useRef(null);
  const pendingDraftDataRef = useRef(null);
  const isSilentDraftRef = useRef(false);

  const [callSaveDraftRevision] = usePost("/flows/save_revision_section", {
    onCompleted: (data) => {
      const id = data?.revision_id;
      if (!id) return;
      setDraftRevisionId(id);
      draftRevisionIdRef.current = id;
      if (!isSilentDraftRef.current)
        swal(l("Cambios guardados%PA629"), l("Se han guardado tus cambios correctamente.%PA631"), "success");
      isSilentDraftRef.current = false;
    },
  });

  const [callGetOrCreateDraft, reqGetOrCreateDraft] = usePost("/flows/get_revision_draft", {
    onCompleted: (data) => {
      const id = data?.revision_id;
      if (!id) return;

      setDraftRevisionId(id);
      draftRevisionIdRef.current = id;

      if (pendingDraftDataRef.current !== null) {
        isSilentDraftRef.current = !!pendingDraftDataRef.current.options?.isSilent;
        callSaveDraftRevision({
          flow_id: flow.id,
          revision_id: id,
          target: pendingDraftDataRef.current.section,
          data: pendingDraftDataRef.current.data,
          revision_type: isDeveloper ? "PRODUCT" : "CLIENT",
          priority: "LOW",
          status: "DRAFT",
          revision_name: "Borrador",
        });
        pendingDraftDataRef.current = null;
      }
    },
  });

  useEffect(() => {
    draftRevisionIdRef.current = draftRevisionId;
  }, [draftRevisionId]);

  const initDraft = () => {
    callGetOrCreateDraft({ flow_id: flow.id });
  };

  const saveDraft = (section, data, options = {}) => {
    const id = draftRevisionIdRef.current;
    isSilentDraftRef.current = !!options.isSilent;
    if (id) {
      callSaveDraftRevision({
        flow_id: flow.id,
        revision_id: id,
        target: section,
        data,
        revision_type: isDeveloper ? "PRODUCT" : "CLIENT",
        priority: "LOW",
        status: "DRAFT",
        revision_name: "Borrador",
      });
    }
    else {
      pendingDraftDataRef.current = { section, data, options };
      callGetOrCreateDraft({ flow_id: flow.id });
    }
  };

  return {
    draftRevisionId,
    draftRevisionIdRef,
    isLoadingDraft: reqGetOrCreateDraft.loading,
    draftData: reqGetOrCreateDraft.data,
    initDraft,
    saveDraft,
  };

};

export { useDraft };
